<template>
	<div>
		<h1>Documentation</h1>

		<div v-show="date">
			<div>Généré le {{date}}</div>
		</div>
		
		<br />
		<div>
			<b-button @click="generate">Générer</b-button>&nbsp;
			<b-button @click="download">Télécharger</b-button>
			<div v-if="launch" class="center_spinner">
				<fade-loader></fade-loader>
				<br /><br />
			</div>
		</div>
		<br />

		<div v-if="documentation">
			<iframe width="100%" onload='javascript:(function(o){o.style.height=(o.contentWindow.document.body.scrollHeight + 20)+"px";}(this));' :srcdoc="documentation" id="iframe" sandbox="allow-forms allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-modals"></iframe>
		</div>

		<div>
			<b-button @click="generate">Générer</b-button>&nbsp;	
			<b-button @click="download">Télécharger</b-button>
		</div>
	</div>
</template>

<script>
	import { uuid } from "vue-uuid";
    import FadeLoader from "vue-spinner/src/FadeLoader.vue";

	import store from "../store";
	import users from "../services/users.js";
	import client from "../services/client.js";
	import documentation_service from "../services/documentation.js";

	export default {
		name: "documentation",
		components: {
			FadeLoader
		},
		data() {
			return {
				documentation: null,
				date: null,
				launch: false
			};
		},
		methods: {
			async setClient()
			{
				let response = await users.getSelf(true);
				var client = response.client;

				if (client && client.details && client.details.documentation && client.details.documentation.date)
					this.date = client.details.documentation.date;
			},
			async generate()
			{
				this.documentation = null;
				this.launch = true;
				this.documentation = await documentation_service.generate();
				this.setClient();
				this.launch = false;
			},
			async download()
			{
				await documentation_service.download();
			}
		},
		created: async function () {
			if (store.state.user.rules && !store.state.user.rules.doc) {
				this.$router.push({ name: "profile" });
			}
			
			this.documentation = await documentation_service.get();
			this.setClient();
        }
	};
</script>

<style></style>
